import { getIdToken as getIdTokenCore } from '@pooflabs/core';
// Wrapper for getIdToken - passes isServer=false for client-side usage
export async function getIdToken() {
    return getIdTokenCore(false);
}
